import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectLoyaltyLevel } from '@bonanza-social/levels/state';
import { CoinBalanceHeaderItem as CoinBalanceHeaderItemBase } from '@bonanza-social/wallet';

function CoinBalanceHeaderItem() {
  const { level } = useSelector(selectLoyaltyLevel) || {};

  return <CoinBalanceHeaderItemBase level={level} />;
}

export default memo(CoinBalanceHeaderItem);
